import { StateDto, CountryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load States Collection Actions
 */
export const loadState = createAction('[State] Load State');

export const loadStateSuccess = createAction(
  '[State] Load State Success',
  props<{ state: StateDto[] }>()
);

export const loadStateFailure = createAction(
  '[State] Load State Failure',
  props<{ error: any }>()
);

/**
 * Select Country to Collection Actions
 */
export const selectCountry = createAction(
  '[Country] Select Country',
  props<{ selectCountry: CountryDto[] }>()
);

export const selectCountrySuccess = createAction(
  '[Country] Select Country Success',
  props<{ newCountry: CountryDto[] }>()
);

export const selectCountryFailure = createAction(
  '[Country] Select Country Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addState = createAction(
  '[State] Add State',
  props<{ newState: StateDto[] }>()
);

export const addStateSuccess = createAction(
  '[State] Add State Success',
  props<{ newState: StateDto[] }>()
);

export const addStateFailure = createAction(
  '[State] Add State Failure',
  props<{ error: any }>()
);

/**
 * Update State Collection Actions
 */
export const updateState = createAction(
  '[State] Update State',
  props<{ updateState: StateDto[] }>()
);

export const updateStateSuccess = createAction(
  '[State] Update State Success',
  props<{ updateState: StateDto[] }>()
);

export const updateStateFailure = createAction(
  '[State] Update State Failure',
  props<{ error: any }>()
);

/**
 * Remove State Collection Actions
 */
export const removeState = createAction(
  '[State] Remove State',
  props<{ ids: string[] }>()
);

export const removeStateSuccess = createAction(
  '[State] Remove State Success',
  props<{ ids: string[] }>()
);

export const removeStateFailure = createAction(
  '[State] Remove State Failure',
  props<{ error: any }>()
);
